// removed by extract-text-webpack-plugin
module.exports = {"button":"_24a48708","rippleWrapper":"_0500ce16","squared":"_57de7fa6","icon":"_30977412","solid":"afc1d629","raised":"c32c8326 _24a48708 _57de7fa6 afc1d629","flat":"f7243650 _24a48708 _57de7fa6","floating":"dee26284 _24a48708 afc1d629","mini":"c27a3552","toggle":"_35544ef1 _24a48708","primary":"c1982a21","accent":"ac8b6519","neutral":"_411a2676","inverse":"e92b3af8"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/button/theme.css
// module id = 5253
// module chunks = 39